import React from 'react';
import { Route, useHistory, Switch } from 'react-router-dom';
import { Security, SecureRoute, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import Home from './Home';
import { oktaAuthConfig } from './config';

const oktaAuth = new OktaAuth(oktaAuthConfig);

// Clear old cached tokens with the old issuer configuration
// This ensures users with cached old issuer values get updated
if (typeof window !== 'undefined') {
  try {
    // Clear the old default storage key if it exists
    const oldStorageKey = 'okta-token-storage';
    if (localStorage.getItem(oldStorageKey)) {
      localStorage.removeItem(oldStorageKey);
    }
    // Also clear from sessionStorage
    if (sessionStorage.getItem(oldStorageKey)) {
      sessionStorage.removeItem(oldStorageKey);
    }
  } catch (e) {
    console.warn('Could not clear old Okta cache:', e);
  }
}

const AppWithRouterAccess = () => {
  const history = useHistory();

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history.replace(toRelativeUrl(originalUri, window.location.origin));
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
    >
      <Switch>
        <SecureRoute path='/' exact={true} component={Home} />
        <Route path='/login/callback' component={LoginCallback} />
      </Switch>
    </Security>
  );
};
export default AppWithRouterAccess;
